
const initialState = {};

export function fetchRentalContract(state = initialState, action) {
  switch(action.type) {
    case 'FETCH_RENTAL_CONTRACT.SUCCESS':
      return {
        ...state,
        contract: action.contract.body,
      };
    default:
      return state;
  }
}
